enum forgotPasswordConstants {
  SUPER_ADMIN = 'SUPER_ADMIN',
}
export default forgotPasswordConstants;
